import PropTypes from 'prop-types';
import React from 'react';
import { getLabelMessage } from '@gef-ui/localization/messages';
import { useDefaultComponentValue } from '../../../../utils/useDefaultComponentValue';
import TableBody from '../../TableBody';
import TableCell from '../../TableCell';
import TableRow from '../../TableRow';
const COMPONENT_NAME = 'TableHasNoResults';
const TableHasNoResults = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, message = 'common:noRecordFound', errorMessage = 'error:unexpected', hasError = false, columnCount = 1, map, ...others } = props;
    if (map.length !== 0) {
        return null;
    }
    const noResultsMessage = hasError ? errorMessage : message;
    return /*#__PURE__*/ React.createElement(TableBody, others, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        colSpan: columnCount
    }, children ? children : getLabelMessage(noResultsMessage))));
};
TableHasNoResults.propTypes = {
    /**
	 * Children - if this prop is present, then no message even default is not shown
	 */ children: PropTypes.node,
    /**
	 * Count of columns for colSpan
	 */ columnCount: PropTypes.number,
    /**
	 * The message shown if hasError is true
	 */ errorMessage: PropTypes.string,
    /**
	 * If there was error loading table data, we may want to show an error
	 */ hasError: PropTypes.bool,
    /**
	 * an array of data
	 */ map: PropTypes.array.isRequired,
    /**
	 * The message shown if the length of map is 0
	 */ message: PropTypes.string
};
export default TableHasNoResults;
